import actions from '../../actionTypes';

export default zones => {
  return {
    type: actions.SET_ZONES_BY_SITE,
    zones
  };
};



// WEBPACK FOOTER //
// ./src/reducers/zones/actions/setZonesBySite.js